import { FC } from 'react';
import CancelledStateMessage from './CancelledStateMessage';
import { DetailsBooking } from 'types';
import ChangeStateMessage from './ChangeStateMessage/ChangeStateMessage';

interface StateMessagingProps {
  booking: DetailsBooking;
}

const StateMessaging: FC<StateMessagingProps> = ({ booking }) => (
  <>
    <CancelledStateMessage booking={booking} />
    <ChangeStateMessage booking={booking} />
  </>
);

export default StateMessaging;
